import { AxiosResponse } from 'axios';
import axios from 'utils/axios';
import { ResponseDataInterface } from 'types';
import { AgentDashboardData, Metrics } from '../types';

export const getAgentDashboardData = (params: any): Promise<AxiosResponse<Metrics<AgentDashboardData>>> =>
  axios.get(`/api/v1/agent/reports/dashboard`, { params });
